import { getSwiperTouchOptions } from './swiperConfig.js'

/** Wie Gallery/Impressionen: auf Mobile immer 1 Slide */
export const SWIPER_MOBILE_BREAKPOINTS = {
  320: {
    slidesPerView: 1,
    spaceBetween: 20
  },
  480: {
    slidesPerView: 1,
    spaceBetween: 20
  },
  900: {
    slidesPerView: 1,
    spaceBetween: 20
  }
}

export function initSwiperInRoot(root, optionOverrides = {}) {
  const $ = window.$
  if (!$ || !root) return null

  const $root = $(root)
  const $container = $root.find('.swiper-container')
  const container = $container[0]
  if (!container) return null

  if (container.swiper) {
    container.swiper.destroy(true, true)
  }

  $container.swiper({
    grabCursor: true,
    paginationClickable: true,
    pagination: $root.find('.swiper-pagination'),
    observer: true,
    observeParents: true,
    ...getSwiperTouchOptions(),
    ...optionOverrides
  })

  return container.swiper || null
}

export function destroySwiperInRoot(root, beforeDestroy) {
  if (!root) return

  const $ = window.$
  if (beforeDestroy && $) {
    beforeDestroy($(root))
  }

  const container = root.querySelector('.swiper-container')
  if (container?.swiper) {
    container.swiper.destroy(true, true)
  }
}

const scheduledTimers = new WeakMap()

export function scheduleSwiperInit(root, optionOverrides = {}, delay = 100) {
  if (!root) return

  const existing = scheduledTimers.get(root)
  if (existing) {
    clearTimeout(existing)
  }

  const timer = setTimeout(() => {
    scheduledTimers.delete(root)
    initSwiperInRoot(root, optionOverrides)
  }, delay)

  scheduledTimers.set(root, timer)
}

export function cancelScheduledSwiperInit(root) {
  if (!root) return

  const timer = scheduledTimers.get(root)
  if (timer) {
    clearTimeout(timer)
    scheduledTimers.delete(root)
  }
}
